import React from 'react';
import { UserRole, AppUser } from '../types';
import { AdminDashboardView } from '../views/admin/AdminDashboardView';
import { PropertyAdminDashboardView } from '../views/property_admin/PropertyAdminDashboardView';
import { BrokerDashboardView } from '../views/broker/BrokerDashboardView';
import { NoRoleHomeView } from '../views/user/NoRoleHomeView';
import type { GoogleGenAI } from '@google/genai';

export interface DashboardViewProps {
  onLogout: () => void;
  firebaseUser?: { uid?: string; email?: string } | null | any;
  appUser: AppUser | null;
  ai?: GoogleGenAI | null;
  preselectedCodes?: string;
  newlyAddedRange?: { startDate: Date; endDate: Date };
  forceOnlyRecent?: boolean;
  onConsumeForceOnlyRecent?: () => void;
}

type RoleViewComponent = React.ComponentType<DashboardViewProps>;

export const roleViewComponentMap: { [key: string]: RoleViewComponent } = {
  [UserRole.SUPERADMIN]: AdminDashboardView,
  [UserRole.ADMIN]: PropertyAdminDashboardView,
  [UserRole.OPERACION]: AdminDashboardView,
  [UserRole.BROKER]: BrokerDashboardView,
  [UserRole.BROKER_INTERNO]: BrokerDashboardView,
  [UserRole.BROKER_PREMIUM]: BrokerDashboardView,
  [UserRole.CLIENTE]: BrokerDashboardView,
  [UserRole.COMERCIAL_INTERNO]: BrokerDashboardView,
  [UserRole.BROKERS_LEADS]: BrokerDashboardView,
  [UserRole.SIN_ROL]: NoRoleHomeView,
};
